<template>
  <div>
    <Header>
      <template #title>
        {{ $t("integrations.poster_connect.title") }}
      </template>
    </Header>

    <PageContainer>
      <div>
        <p class="iqos-comment" v-if="busy">
          {{ $t("integrations.poster_connect.wait") }}
        </p>

        <p class="green-5-color" v-if="success">
          {{ $t("integrations.poster_connect.success") }}
        </p>

        <BaseButton
          class="mt-16"
          v-if="success"
          variant="secondary"
          size="md"
          color="v1-grey-10"
          @click="$router.replace('/pos_integrations/poster')"
        >
          {{ $t("integrations.poster_connect.return") }}
        </BaseButton>
      </div>

      <p class="red-4-color" v-if="!success && !busy">
        {{ $t("integrations.poster_connect.failed") }}
      </p>
    </PageContainer>
  </div>
</template>

<script>
import PosterAPI from "@/api/poster";
import JoinAPI from "@/api/join";

export default {
  data() {
    return {
      busy: true,
      success: false,

      selecting_cafe: false,
    };
  },
  methods: {
    executeIntegration(account, code) {
      PosterAPI.finish(this.$store.state.cafe._id, account, code)
        .then((ok) => {
          this.busy = false;
          this.success = true;

          this.$store.dispatch("fetchCafe", this.$store.state.cafe._id);

          context.dispatch("integrations/fetchConnected", {
            cafe_id: this.$store.state.cafe._id,
          });

          this.$store.dispatch("auditlog/write", {
            type: "poster_integrate",
            payload: {},
          });
        })
        .catch((error) => {
          this.busy = false;
        });
    },
    executeRegistration(account, code) {
      JoinAPI.sendPosterApplication(account, code)
        .then((data) => {
          // this.busy = false;

          if (data.created_new_account) {
            window.location.href = `https://dashboard.qrwaiter.com.ua/confirm_register/${data.confirm_id}`;
          } else {
            this.$store.dispatch('init').then(data => {
              this.$router.push('/general');
            }).catch(() => {
              window.location.reload();
            })
          }

          
        })
        .catch((error) => {
          this.busy = false;
        });
    },
    checkMultipleCafes() {
      const account = this.$route.query.account;
      const code = this.$route.query.code;

      this.$store
        .dispatch("fetchCorporateCafes")
        .then((ok) => {
          setTimeout(() => {
            this.executeIntegration(account, code);
            return;
          }, 3500);
        })
        .catch((error) => {
          this.busy = false;
        });
    },
  },
  mounted() {
    const account = this.$route.query.account;
    const code = this.$route.query.code;

    if (this.$store.state.loggedIn) {
      this.checkMultipleCafes();
    } else {
      this.executeRegistration(account, code);
    }
  },
  computed: {
    corporate_cafes() {
      return this.$store.state.corporate_cafes;
    },
  },
};
</script>

<style>
</style>